module.exports = __webpack_public_path__ + "img/drag.4a19e202.svg";